var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _circle3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "#4e4034",
    stroke: "#b08d57",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "#6b4f4f",
    stroke: "#8b4513",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 5,
    x2: 50,
    y2: 15,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 73.5,
    y1: 11.5,
    x2: 68.5,
    y2: 20,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 31,
    x2: 80,
    y2: 35,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 50,
    x2: 85,
    y2: 50,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 69,
    x2: 80,
    y2: 65,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 73.5,
    y1: 88.5,
    x2: 68.5,
    y2: 80,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 95,
    x2: 50,
    y2: 85,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 88.5,
    x2: 31.5,
    y2: 80,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 69,
    x2: 20,
    y2: 65,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 50,
    x2: 15,
    y2: 50,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 31,
    x2: 20,
    y2: 35,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 26.5,
    y1: 11.5,
    x2: 31.5,
    y2: 20,
    stroke: "#ffd700",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 15,
    fill: "#b08d57"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 20,
    width: 4,
    height: 15,
    fill: "#ffd700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnob);
export default __webpack_public_path__ + "static/media/knob.095d2dbe6e25e9c6b799578b142a34a6.svg";
export { ForwardRef as ReactComponent };